import { getFeatureFlags } from "hooks/useFeatureFlags";

export const featureFlagLoaderCheck = (featureFlag: string) => async () => {
  const { flags } = await getFeatureFlags();
  if (!flags[featureFlag]) {
    throw new Response("Not Found", { status: 404 });
  }
};
